import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import getFilters from '../../services/filters/get/index.tsx';
import { RETRIEVE, retrieved, retrieveFailed } from '../../state/actions/filters/index.tsx';
import { getIsAdmin } from '../../state/selectors/app/index.tsx';
import { getFilter } from '../../state/selectors/query/index.tsx';
import type { State, Action } from '../../state/types.tsx';
import { getServiceRequest } from './selectors.tsx';

const retrieveFilters = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) => {
	const getFiltersRequestAction$ = action$.ofType(RETRIEVE);

	return getFiltersRequestAction$.mergeMap(() => {
		const state = store.getState();
		const request = getServiceRequest(state);
		const filter = getFilter(state);
		const isAdmin = getIsAdmin(state);

		// @ts-expect-error - TS2345 - Type 'undefined' is not assignable to type 'Filter'.
		return Observable.fromPromise(getFilters(request, filter, isAdmin))
			.mergeMap((result) => Observable.of(retrieved(result)))
			.takeUntil(getFiltersRequestAction$)
			.catch((error) => {
				fireErrorAnalytics({
					error,
					meta: {
						id: 'retrieveFilters',
						packageName: 'jiraFiltersMain',
						teamName: 'keystone',
					},
				});
				return Observable.of(retrieveFailed());
			});
	});
};

export default retrieveFilters;
